import {
	downloadFile,
	FormResponse,
	sendInvoice,
} from '@/api/northlight-renewals';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

export function Review() {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const formResponse = queryClient.getQueryData<FormResponse>(['formResponse']);
	const { mutate, isPending } = useMutation({
		mutationFn: sendInvoice,
	});
	const handleSendInvoice = () => {
		if (!formResponse) return;
		const payload = {
			legalname: formResponse.legalname,
			recipient: formResponse.recipient,
			attachmentname: formResponse.attachmentname,
			attachmentencoded: formResponse.attachmentencoded,
			body: formResponse.body,
			insert_ts: formResponse.insert_ts,
			deliverytimeest: formResponse.deliverytimeest,
			bcc: formResponse.bcc,
			emailtype: formResponse.emailtype,
			sender: formResponse.sender,
			subject: formResponse.subject,
		};
		mutate(payload);
		navigate('/northlight-renewal');
	};
	return (
		<>
			<h1 className="mb-4 text-center text-2xl font-semibold">Review Proposal</h1>
			<div className="mx-auto max-w-md space-y-6">
				<div className="flex gap-4">
					<Button
						variant="outline"
						onClick={() =>
							downloadFile({ filename: formResponse?.attachmentname })
						}
					>
						Click to Download Insured Invoice
					</Button>
					<Button
						variant="outline"
						onClick={() => downloadFile({ filename: formResponse?.attachmentencoded })}
					>
						Click to Download Agent Invoice
					</Button>
				</div>
				<div>
					<div>
						<Label>Bill To:</Label>
						<Input value={formResponse?.legalname} readOnly />
					</div>
					<div>
						<Label>Agent Email:</Label>
						<Input value={formResponse?.recipient} readOnly />
					</div>
				</div>
				<div className="flex justify-center gap-4 pt-2">
					<Button onClick={handleSendInvoice} disabled={isPending}>
						{isPending ? 'Sending' : 'Email Renewal Packet'}
					</Button>
					<Button onClick={() => navigate('/northlight-renewal')}>Cancel</Button>
				</div>
			</div>
		</>
	);
}
